<div class="dialog-container">
  <div class="logo-container">
    <img [src]="logoSrc" alt="{{ 'labels.logo' | translate }}" class="logo">
  </div>
  <h2 mat-dialog-title>{{ 'messages.registrationSuccessful' | translate }}</h2>
  <mat-dialog-content>
    <p class="success-message">{{ 'messages.registrationCompleted' | translate }}</p>
    <p class="email-message">{{ 'messages.temporaryPasswordWillBeSent' | translate }} <strong>{{data.email}}</strong></p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button class="ok-button" [mat-dialog-close]="true">{{ 'buttons.ok' | translate }}</button>
  </mat-dialog-actions>
</div> 